import { useTranslation } from 'react-i18next';
import { Eye, Pencil, Undo2 } from 'lucide-react';
import { useWorkspace } from '../../context/WorkspaceContext';

/** Shown while browsing a move that was shared with the user. */
export function WorkspaceBanner() {
  const { t } = useTranslation();
  const { isOwn, role, ownerName, exitShared } = useWorkspace();
  if (isOwn) return null;

  const editor = role === 'editor';
  return (
    <div
      className="print:hidden bg-blue-tint text-blue border-b hairline px-4 py-2 flex items-center gap-2 text-[13px]"
      data-testid="workspace-banner"
    >
      {editor ? <Pencil className="size-4 shrink-0" /> : <Eye className="size-4 shrink-0" />}
      <span className="min-w-0 flex-1 truncate" dir="auto">
        {t('share.bannerViewing', { name: ownerName || '' })}
        {' · '}
        {editor ? t('share.roleEditor') : t('share.roleViewer')}
      </span>
      <button
        type="button"
        onClick={exitShared}
        className="inline-flex items-center gap-1 font-medium hover:underline shrink-0"
      >
        <Undo2 className="size-3.5" />
        {t('share.backToMine')}
      </button>
    </div>
  );
}
